// extracted by mini-css-extract-plugin
module.exports = {"autoComplete":"RR","error":"SR","disabled":"TR"};